import React, { useState, useEffect } from 'react';
import LoginForm from './components/auth/LoginForm';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import DashboardLayout from './components/layout/DashboardLayout';
import Dashboard from './pages/Dashboard';
import Owners from './pages/Owners';
import Cars from './pages/Cars';
import Drivers from './pages/Drivers';
import PotentialDrivers from './pages/PotentialDrivers';
import PotentialDriverDetail from './pages/PotentialDriverDetail';
import Sales from './pages/Sales';
import Settings from './pages/Settings';
import DriverGraph from './pages/DriverGraph';
import DriverSpecificSales from './pages/DriverSpecificSales';
import DriverMonthlySales from './pages/DriverMonthlySales';
import DriverSpecificExpenses from './pages/DriverSpecificExpenses';

const AppContent = () => {
    const { isAuthenticated } = useAuth();

    // Detect current page from URL
    const getPageFromUrl = () => {
        const path = window.location.pathname;
        if (path === '/owners') return 'owners';
        if (path === '/cars') return 'cars';
        if (path === '/drivers') return 'drivers';
        if (path === '/sales') return 'sales';
        if (path === '/potential_drivers') return 'potential_drivers';
        if (path.startsWith('/potential_drivers/')) return 'potential_driver_detail';
        if (path === '/settings') return 'settings';
        if (path === '/home/driver_graph') return 'driver_graph';
        if (path === '/dashboard/admin') return 'dashboard';
        if (path === '/sales/driver_specific_sales') return 'driver_specific_sales';
        if (path === '/sales/driver_specific_sales_this_month') return 'driver_monthly_sales';
        if (path === '/sales/driver_specific_expenses') return 'driver_specific_expenses';
        return 'dashboard';
    };

    const [currentPage, setCurrentPage] = useState(getPageFromUrl());

    // Update page when URL changes
    useEffect(() => {
        const handleLocationChange = () => {
            setCurrentPage(getPageFromUrl());
        };

        window.addEventListener('popstate', handleLocationChange);
        return () => window.removeEventListener('popstate', handleLocationChange);
    }, []);

    if (!isAuthenticated) {
        return <LoginForm />;
    }

    const renderPage = () => {
        switch (currentPage) {
            case 'dashboard':
                return <Dashboard />;
            case 'owners':
                return <Owners />;
            case 'cars':
                return <Cars />;
            case 'drivers':
                return <Drivers />;
            case 'sales':
                return <Sales />;
            case 'potential_drivers':
                return <PotentialDrivers />;
            case 'potential_driver_detail':
                return <PotentialDriverDetail />;
            case 'settings':
                return <Settings />;
            case 'driver_graph':
                return <DriverGraph />;
            case 'driver_specific_sales':
                return <DriverSpecificSales />;
            case 'driver_monthly_sales':
                return <DriverMonthlySales />;
            case 'driver_specific_expenses':
                return <DriverSpecificExpenses />;
            default:
                return <Dashboard />;
        }
    };

    return (
        <DashboardLayout currentPage={currentPage} onNavigate={setCurrentPage}>
            {renderPage()}
        </DashboardLayout>
    );
};

const App = () => {
    return (
        <AuthProvider>
            <ThemeProvider>
                <AppContent />
            </ThemeProvider>
        </AuthProvider>
    );
};

export default App;
